import React, { useCallback, useEffect, useMemo, useState } from "react";
import images from "../../themes/appImage";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  createPostLoad,
  createPostModalHandler,
  toxicPostLoad,
} from "../../redux/slices/community.slice";
import CommunityPosts from "./CommunityPost/CommunityPosts";

const postTypeHandler = (type, text) => {
  if (type === "image/jpeg" || type === "image/png") {
    if (text === "") {
      return "postOnly";
    } else {
      return "imageWithText";
    }
  } else if (type === "video/mp4") {
    if (text === "") {
      return "videoOnly";
    } else {
      return "videoWithText";
    }
  } else if (type === "image/gif") {
    if (text === "") {
      return "gifOnly";
    } else {
      return "textWithGIF";
    }
  } else {
    return "textOnly";
  }
};

const initialStateCreatePostPayload = {
  text: "",
  postType: "textOnly",
  type: "community",
  file: "",
};

const Community = () => {
  const dispatch = useDispatch();
  const { createPostLoader, postCreatedSuccess, createdData, createPostModal } =
    useSelector((state) => state.CommunityReducer);
  const commonReducerState = useSelector((state) => state.commonReducer);

  const [listPayload, setListPayload] = useState({
    limit: 20,
    offset: 0,
  });
  const memoListPayloadState = useMemo(() => listPayload, [listPayload]);
  const setListPayloadMemo = useCallback(
    (data) => {
      setListPayload(data);
    },
    [listPayload]
  );

  const [localPostList, setLocalPostList] = useState([]);
  const memoLocalPostListState = useMemo(() => localPostList, [localPostList]);
  const setLocalPostListMemo = useCallback(
    (data) => {
      setLocalPostList(data);
    },
    [localPostList]
  );

  const [listDone, setListDone] = useState(false);
  const [createPostPayload, setCreatePostPayload] = useState(
    initialStateCreatePostPayload
  );

  const memoListDoneState = useMemo(() => listDone, [listDone]);

  const setListDoneMemo = useCallback(
    (data) => {
      setListDone(data);
    },
    [listDone]
  );

  const uploadFileType =
    createPostPayload?.file?.type?.length > 0
      ? createPostPayload?.file?.type
      : undefined;

  useEffect(() => {
    console.log("workinggg", postCreatedSuccess);
    if (postCreatedSuccess) {
      const clone = [...localPostList];
      clone.unshift({
        ...createdData,
        createdByMe: true,
      });
      setLocalPostList(clone);
      setCreatePostPayload(initialStateCreatePostPayload);
      setListDone(false);
    }
  }, [postCreatedSuccess]);

  console.log("posta", postCreatedSuccess);

  useEffect(() => {
    if (
      commonReducerState?.removeCommentSuccessIds.commentId &&
      commonReducerState?.removeCommentSuccessIds.postId
    ) {
      setLocalPostList((pre) =>
        [...pre].map((item) =>
          item._id == commonReducerState?.removeCommentSuccessIds?.postId
            ? { ...item, comment: item.comment > 0 ? item.comment - 1 : 0 }
            : item
        )
      );
    }
  }, [commonReducerState?.removeCommentSuccessIds]);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setCreatePostPayload((pre) => ({ ...pre, file }));
  };

  const postCreateHandler = () => {
    const form = new FormData();
    const postType = postTypeHandler(uploadFileType, createPostPayload?.text);
    form.append("text", createPostPayload.text);
    form.append("postType", postType);
    form.append("type", createPostPayload.type);
    form.append("file", createPostPayload.file);

    dispatch(
      toxicPostLoad({
        apiKey: process.env.REACT_APP_API_URL,
        comment: createPostPayload.text,
        form,
      })
    );
  };

  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Community</h1>
            {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
          </div>
          {/* <div className="add-new-button">
                            <button onClick={() => setModal1Open(true)} >Add Community Guidelines</button>
                        </div> */}
        </div>

        <div className="add-post-dis-mental-fit">
          <div className="community-page-width">
            <div className="text-box-div">
              <div className="textarea-box">
                <textarea
                  id="w3review"
                  value={createPostPayload.text}
                  onChange={(e) =>
                    setCreatePostPayload((pre) => ({
                      ...pre,
                      text: e.target.value,
                    }))
                  }
                  placeholder="Write something "
                  rows="3"
                  cols="50"
                ></textarea>
                <div className="create-post-comm">
                  <img
                    onClick={() => dispatch(createPostModalHandler())}
                    src={images.camera}
                    alt="camera"
                  />
                  <Button
                    disabled={
                      createPostPayload.text.length == 0 &&
                      uploadFileType == undefined
                    }
                    loading={createPostLoader}
                    onClick={postCreateHandler}
                    style={
                      createPostPayload?.text?.length > 0
                        ? {
                            minWidth: "70px",
                            height: "36px",
                            display: "flex",
                            padding: "6px",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#7c63a4",
                            color: "white",
                          }
                        : {
                            minWidth: "70px",
                            height: "36px",
                            display: "flex",
                            padding: "6px",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#7c63a4",
                            color: "white",
                          }
                    }
                  >
                    Post
                  </Button>
                </div>
              </div>
            </div>
            <CommunityPosts
              localPostList={memoLocalPostListState}
              setLocalPostList={setLocalPostListMemo}
              setListPayload={setListPayloadMemo}
              listPayload={memoListPayloadState}
              listDone={memoListDoneState}
              setListDone={setListDoneMemo}
            />
          </div>
        </div>
      </div>

      <Modal
        title=""
        className="modal-update create-modal"
        centered
        visible={createPostModal}
        closable={true}
        onCancel={() => {
          setCreatePostPayload((pre) => ({ ...pre, file: "" }));
          dispatch(createPostModalHandler());
        }}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user create-post-modal">
            <h1>Create Post</h1>
          </div>
          <div className="create-metail-post-modal">
            <div className="post-disp">
              <div className="user-pofile">
                <img src={images.matleFitLogo} alt="userProf" />
              </div>
              <div className="user-name">
                <h2>MentalFit</h2>
              </div>
            </div>
            <div className="input-text-field">
              <input
                type="text"
                value={createPostPayload.text}
                onChange={(e) =>
                  setCreatePostPayload((pre) => ({
                    ...pre,
                    text: e.target.value,
                  }))
                }
                placeholder="Write something lorem ipsum..."
              />
            </div>
            <div className="upload-post-sec">
              <div className="click-to-upload relative">
                {uploadFileType !== undefined && (
                  <div
                    onClick={() =>
                      setCreatePostPayload((pre) => ({ ...pre, file: "" }))
                    }
                    className="bg-white cursor-pointer p-2 w-5 h-5 absolute -right-3 -top-3 border border-black rounded-full flex justify-center items-center"
                  >
                    x
                  </div>
                )}
                <div className="upload-file new-up-file ">
                  {uploadFileType !== undefined &&
                  uploadFileType == "video/mp4" ? (
                    <video
                      controls
                      style={{ maxWidth: "100%", height: "auto" }}
                    >
                      <source
                        src={URL.createObjectURL(createPostPayload.file)}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : uploadFileType !== undefined ? (
                    <img
                      src={URL.createObjectURL(createPostPayload.file)}
                      alt="upload"
                    />
                  ) : null}
                  {uploadFileType == undefined && (
                    <>
                      <div className="upload-center-text">
                        <label htmlFor="fileUpload">
                          <p>
                            <span>
                              <img src={images.upload} alt="upload" />
                            </span>{" "}
                            Click here to upload
                          </p>
                        </label>
                        <input
                          type="file"
                          id="fileUpload"
                          style={{ display: "none" }}
                          onChange={handleFileUpload}
                        />
                      </div>
                      <p className="image-disp">
                        File Format: .JPEG, .PNG, MP4
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="create-post-comm modal-bott-section">
            <div className="opacity-0">
              <img src={images.camera} alt="camera" />
            </div>
            <Button
              disabled={
                createPostPayload.text.length == 0 &&
                uploadFileType == undefined
              }
              loading={createPostLoader}
              onClick={postCreateHandler}
              style={
                createPostPayload?.text?.length > 0
                  ? {
                      minWidth: "70px",
                      height: "36px",
                      display: "flex",
                      padding: "6px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#7c63a4",
                      color: "white",
                    }
                  : {
                      minWidth: "70px",
                      height: "36px",
                      display: "flex",
                      padding: "6px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#7c63a4",
                      color: "white",
                    }
              }
            >
              Post
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default Community;
